// extracted by mini-css-extract-plugin
export default {"card":"entities-assigned_card__KES0e"};